import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { JustCreatedState } from '../shared/editor-page/use-just-created';

import { blankBundleForm, toCreateRequest } from './editor/bundle-form';
import { GiftPassBundleEditor } from './editor/GiftPassBundleEditor';
import { giftPassBundlePath } from './gift-pass-bundles-paths';
import { useCreateGiftPassBundle } from './use-gift-pass-bundles';

export default function GiftPassBundleCreatePage() {
  const create = useCreateGiftPassBundle();
  const navigate = useNavigate();
  const [initial] = useState(blankBundleForm);
  return (
    <GiftPassBundleEditor
      initial={initial}
      persist={(values) => create.mutateAsync(toCreateRequest(values))}
      onSaved={(bundle) => {
        const state: JustCreatedState = { created: true };
        navigate(giftPassBundlePath(bundle.id), { replace: true, state });
      }}
    />
  );
}
